import React, { useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';
import { ModuleId } from '../../types';
import { GroupId } from '../../config/systemConfig';
import { useFocusTrap } from '../../hooks/useFocusTrap';
interface ValidationErrorModalProps {
  error: {
    moduleId: ModuleId;
    message: string;
    hasContent: boolean;
  };
  selectedGroup: GroupId;
  onClose: () => void;
  onSwitchToGroup6: () => void;
  onNavigateToModules: () => void;
}
export function ValidationErrorModal({
  error,
  selectedGroup,
  onClose,
  onSwitchToGroup6,
  onNavigateToModules
}: ValidationErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  // Escape key to close
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-5187" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-5188">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="validation-error-title" className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8" data-id="element-5189">
          <div className="text-center" data-id="element-5190">
            <div className="text-6xl mb-4" data-id="element-5191">📚</div>
            <h2 id="validation-error-title" className="text-2xl font-bold text-slate-900 mb-3" data-id="element-5192">
              Nog geen vragen beschikbaar
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-5193">
              Voor <strong data-id="element-5194">{error.moduleId}</strong> zijn er nog geen vragen
              beschikbaar voor groep {selectedGroup}.
            </p>

            <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-4 mb-6 text-left" data-id="element-5195">
              <div className="flex items-start gap-3" data-id="element-5196">
                <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-5197" />
                <div className="text-sm text-amber-800" data-id="element-5198">
                  <p className="font-semibold mb-2" data-id="element-5199">Wat kun je doen?</p>
                  <ul className="space-y-1 list-disc list-inside" data-id="element-5200">
                    <li data-id="element-5201">Probeer een ander vak</li>
                    {selectedGroup !== 6 && <li data-id="element-5202">Wissel naar groep 6 in de instellingen</li>}
                    <li data-id="element-5203">Kom later terug voor nieuwe vragen</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex gap-3" data-id="element-5204">
              {selectedGroup !== 6 && <Button onClick={onSwitchToGroup6} variant="secondary" size="lg" fullWidth data-id="element-5205">
                  Wissel naar Groep 6
                </Button>}
              <Button onClick={onNavigateToModules} variant="primary" size="lg" fullWidth data-id="element-5206">
                Bekijk andere vakken
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>;
}